/* global google */
var youbora = require('youboralib')
var manifest = require('../../manifest.json')

youbora.adapters.AkamaiDaiIma = youbora.Adapter.extend({

  constructor: function (player, playerAdapter) {
    youbora.adapters.AkamaiDaiIma.__super__.constructor.call(this, player)
    this.playerAdapter = playerAdapter
  },

  /** Override to return current plugin version */
  getVersion: function () {
    return manifest.version + '-' + manifest.name + '-DAI-' + manifest.tech
  },

  /** Override to return current playhead of the video */
  getPlayhead: function () {
    var ret = 0
    if (this.flags.isJoined) {
      ret = this.getDuration() - this.player.adTimeRemaining
    }
    return ret
  },

  /** Override to return video duration */
  getDuration: function () {
    return this.player.currentAd.duration
  },

  /** Override to return rendition */
  getRendition: function () {
    var ret = null
    if (this.width && this.height) {
      ret = this.width + 'x' + this.height
    }
    return ret
  },

  /** Override to return title */
  getTitle: function () {
    return this.title
  },

  /** Override to return title2 */
  getTitle2: function () {
    return this.advertiser
  },

  /** Override to return player version */
  getPlayerVersion: function () {
    return google.ima.VERSION
  },

  /** Override to return player's name */
  getPlayerName: function () {
    return 'DAI-IMA'
  },

  getGivenAds: function () {
    return this.totalAds
  },

  getAudioEnabled: function () {
    var ret = null
    if (this.player.proxy && this.player.proxy.adsManager && this.player.proxy.adsManager.getVolume) {
      ret = this.player.proxy.adsManager.getVolume() !== 0
    }
    return ret
  },

  getIsSkippable: function () {
    var ret = false
    if (this.player.proxy && this.player.proxy.adsManager && this.player.proxy.adsManager.getCurrentAd()) {
      ret = this.player.proxy.adsManager.getCurrentAd().g.skippable
    }
    return ret
  },

  getIsFullscreen: function () {
    var ret = false
    if (!this.contentPlayer) {
      this.contentPlayer = this.plugin.getAdapter().player.viewComponent
    }
    if (this.contentPlayer && this.contentPlayer.clientWidth && this.contentPlayer.clientHeight) {
      ret = (window.innerHeight <= this.contentPlayer.clientHeight + 30 && window.innerWidth <= this.contentPlayer.clientWidth + 30)
    }
    return ret
  },

  getIsVisible: function () {
    if (!this.contentPlayer) {
      this.contentPlayer = this.plugin.getAdapter().player.viewComponent
    }
    return youbora.Util.calculateAdViewability(this.contentPlayer)
  },

  /** Override to return current ad position (only ads) */
  getPosition: function () {
    var ret = this.adPosition || youbora.Constants.AdPosition.Midroll
    if (this.plugin.getAdapter() && !this.plugin.getAdapter().flags.isJoined) {
      ret = youbora.Constants.AdPosition.Preroll
    }
    if (this.isDAI && this.plugin.getAdapter() && this.plugin.getAdapter().getIsLive()) {
      ret = youbora.Constants.AdPosition.Midroll
    }
    return ret
  },

  getCreativeId: function () {
    var ret = null
    if (this.player.proxy && this.player.proxy.adsManager &&
      this.player.proxy.adsManager.getCurrentAd()) {
      ret = this.player.proxy.adsManager.getCurrentAd().g.creativeId
    }
    return ret
  },

  /** Register listeners to this.player. */
  registerListeners: function () {
    // References
    this.references = {}
    // DAI
    var eventDAI = google.ima.dai.api.StreamEvent.Type
    this.references[eventDAI.SKIPPED] = this.skippedListener.bind(this)
    this.references[eventDAI.ERROR] = this.errorDAIListener.bind(this)
    this.references[eventDAI.AD_BREAK_STARTED] = this.startDAIListener.bind(this)
    this.references[eventDAI.AD_BREAK_ENDED] = this.stopDAIListener.bind(this)
    this.references[eventDAI.AD_PERIOD_ENDED] = this.stopDAIListener.bind(this)
    this.references[eventDAI.AD_PROGRESS] = this.progressDAIListener.bind(this)
    this.references[eventDAI.CLICK] = this.clickDAIListener.bind(this)
    this.references[eventDAI.COMPLETE] = this.stopDAIListener.bind(this)
    this.references[eventDAI.STARTED] = this.joinDAIListener.bind(this)
    this.references[eventDAI.AD_PERIOD_STARTED] = this.joinDAIListener.bind(this)
    this.references[eventDAI.FIRST_QUARTILE] = this.firstQuartileListener.bind(this)
    this.references[eventDAI.MIDPOINT] = this.secondQuartileListener.bind(this)
    this.references[eventDAI.THIRD_QUARTILE] = this.thirdQuartileListener.bind(this)
    // Register listeners
    if (this.player && this.references) {
      Object.keys(this.references).forEach(function (key) {
        this.player.addEventListener(key, this.references[key])
      }.bind(this))
    }
  },

  /** Unregister listeners to this.player. */
  unregisterListeners: function () {
    if (this.monitor) this.monitor.stop()
    // unregister listeners
    if (this.player && this.references) {
      Object.keys(this.references).forEach(function (key) {
        this.player.removeEventListener(key, this.references[key])
      }.bind(this))
      this.references = {}
    }
  },

  skippedListener: function (e) {
    this.fireSkip()
  },

  /** DAI **/
  errorDAIListener: function (e) {
    this.fireError()
    this.fireStop()
  },
  startDAIListener: function (e) {
    this.isDAI = true
    this.playhead = 0
    this.adPosition = this.getAdPosition()
    this.duration = null
    this.plugin.fireInit() // if preroll
    this.fireStop()
    this.fireStart()
  },
  progressDAIListener: function (e) {
    this.playhead = e.getStreamData()['adProgressData']['currentTime']
  },
  clickDAIListener: function (e) {
    this.fireClick()
  },
  stopDAIListener: function (e) {
    this.fireStop({ adPlayhead: this.duration })
    if (this.playerAdapter) this.playerAdapter.fireResume()
    this.fireBreakStop()
  },
  joinDAIListener: function (e) {
    var adData = e.data
    this.duration = adData.duration
    this.title = adData.title
    this.advertiser = adData.advertiser
    if (this.playerAdapter) this.playerAdapter.firePause()
    this.startDAIListener()
    this.fireJoin()
  },

  firstQuartileListener: function (e) {
    this.fireQuartile(1)
  },

  secondQuartileListener: function (e) {
    this.fireQuartile(2)
  },

  thirdQuartileListener: function (e) {
    this.fireQuartile(3)
  },

  getAdPosition: function () {
    var ret = youbora.Constants.AdPosition.Midroll
    if (!this.isDAI) {
      switch (this.player.currentAd.metadata.position) {
        case 0:
          ret = youbora.Constants.AdPosition.Preroll
          break
        case -1:
          ret = youbora.Constants.AdPosition.Postroll
      }
    } else {
      if (this.playerAdapter) {
        if (!this.playerAdapter.flags.isJoined || this.playerAdapter.getPlayhead() < 1) {
          ret = youbora.Constants.AdPosition.Preroll
        }
      }
    }
    return ret
  }
})

module.exports = youbora.adapters.AkamaiDaiIma
